import React, { useMemo } from 'react'

import { Spinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import DataTable from 'Pods/Shared/DataTable/DataTable'

import RefundsModal from './RefundsModal'
import { usePaymentsInformation } from '../../../Hooks/usePaymentsInformation'
import EmptyMessage from '../../EmptyMessage'

const renderMoneyValue = ({ value }) => <p>${value || '0.00'}</p>

const renderPayoutFees = ({ value, onRefundsClick }) => {
  const {
    previous_fee: previousFee,
    refunds,
    withholding_tax: withholdingTax,
    total,
    refund_ids: refundIds,
  } = value || {}

  return (
    <p>
      Previous Payout Fee: ${previousFee || '0.00'}
      <br />
      <span>
        Refunds:{' '}
        {refundIds && refundIds.length ? (
          <a href="#" onClick={(e) => onRefundsClick(e, refundIds)}>
            ${refunds || '0.00'}
          </a>
        ) : (
          '$0.00'
        )}
      </span>
      {Number(withholdingTax) > 0 && (
        <>
          <br />
          Withholding Tax: ${withholdingTax}
        </>
      )}
      <br />
      Total Deductions: ${total || '0.00'}
    </p>
  )
}

function PaymentsInfo() {
  const {
    paymentsInformation,
    isLoading,
    refundsState,
    handleRefundsClick,
    handleCloseRefundsModal,
  } = usePaymentsInformation()

  const columns = useMemo(
    () => [
      { key: 'payoutType', header: 'Payout Type' },
      { key: 'paymentDate', header: 'Payment Date' },
      { key: 'paymentMethod', header: 'Payment Method' },
      { key: 'transactionId', header: 'Transaction ID' },
      { key: 'revenue', header: 'Earnings', cell: renderMoneyValue },
      {
        key: 'payoutFees',
        header: 'Deductions',
        cell: ({ value }) => renderPayoutFees({
          value,
          onRefundsClick: handleRefundsClick,
        }),
      },
      { key: 'donations', header: 'Donations', cell: renderMoneyValue },
      { key: 'payoutAmount', header: 'Payout Amount', cell: renderMoneyValue },
      { key: 'status', header: 'Status' },
    ],
    [handleRefundsClick]
  )

  if (isLoading) {
    return (
      <div className="spinner-container">
        <Spinner />
      </div>
    )
  }

  return (
    <>
      <DataTable
        columns={columns}
        data={paymentsInformation || []}
        emptyMessage={
          <EmptyMessage title="No payments information available!" />
        }
      />

      <RefundsModal
        isOpen={refundsState.isOpen}
        onClose={handleCloseRefundsModal}
        refundsData={refundsState.refundsData}
        isLoading={refundsState.isLoading}
      />
    </>
  )
}

export default PaymentsInfo
